<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form :model="table.where" label-width="77px" class="ele-form-search"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-col :md="6" :sm="12">
                        <el-form-item label="标题:">
                            <el-input v-model="table.where.title" placeholder="请输入标题" clearable />
                        </el-form-item>
                    </el-col>


                    <el-col :md="6" :sm="12">
                        <el-form-item label="状态:">
                            <el-select v-model="table.where.show_status" placeholder="请选择状态" clearable
                                class="ele-fluid">
                                <el-option label="正常" value="1" />
                                <el-option label="隐藏" value="0" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :md="6" :sm="12">
                        <el-form-item label="状态:">
                            <el-select v-model="table.where.siteswitch" placeholder="请选择状态" clearable class="ele-fluid">
                                <el-option label="隐藏" value="0" />
                                <el-option label="正常" value="1" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :md="6" :sm="12">
                        <div class="ele-form-actions">
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:ceshi:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:ceshi:dall')">批量删除
                </el-button>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <el-table-column prop="title_unit" label="金额（元）" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="phone" label="手机号" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="title" label="标题" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="store_num" label="商城数量" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="status" label="状态" sortable="custom" :resizable="false" min-width="120">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.status" @change="status(row)" :active-value="1"
                                :inactive-value="2" />
                        </template>
                    </el-table-column>

                    <el-table-column prop="show_status" label="状态" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="siteswitch" label="状态" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="flot_price" label="小数输入框" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="area_text" label="文本框" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="datetime" label="时间选择器" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="date_info" label="日期组件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="timestamp" label="日期时间组件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="datetimessss" label="时间日期其他" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="user_id" label="会员id单选" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="user_ids" label="多id合集" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="admin_id" label="管理员id" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="admin_ids" label="管理员id多选" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="store_goods_category_id" label="关联表id" sortable="custom"
                        show-overflow-tooltip min-width="120" />

                    <el-table-column prop="store_goods_category_ids" label="关联表id多选" sortable="custom"
                        show-overflow-tooltip min-width="120" />

                    <el-table-column prop="sort" label="权重" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="smallimage" label="单图" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="smallimages" label="多图" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="attachfile" label="单文件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="attachfiles" label="多文件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="miniavatar" label="当头像" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="miniavatars" label="多头像" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="maincontent" label="富文本" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="timelist" label="单选" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="timeslist" label="多选下拉" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="hobbydata" label="单选" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="hobbysdata" label="多选" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="daterange" label="日期范围" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="datetimierange" label="日期时间范围" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="timerange" label="时间范围" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="decimal_price" label="金额小数" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="city_map" label="地图选址" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="address_region" label="地区选址" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:ceshi:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此测试吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:ceshi:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改测试':'修改测试'" :visible.sync="showEdit" width="450px" @closed="editForm={}"
            :destroy-on-close="true" :lock-scroll="false">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">

                <el-form-item label="金额（元）：" prop="title_unit">
                    <el-input v-model="editForm.title_unit" placeholder="请输入金额（元）" clearable />
                </el-form-item>

                <el-form-item label="手机号：" prop="phone">
                    <el-input-number v-model="editForm.phone" controls-position="right" :min="0" placeholder="请输入手机号"
                        class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="标题：" prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入标题" clearable />
                </el-form-item>

                <el-form-item label="商城数量：" prop="store_num">
                    <el-input-number v-model="editForm.store_num" controls-position="right" :min="0"
                        placeholder="请输入商城数量" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="状态：" prop="status">
                    <el-switch v-model="editForm.status" active-text="是" inactive-text="否">
                    </el-switch>
                </el-form-item>

                <el-form-item label="状态：" prop="show_status">
                    <el-select v-model="editForm.show_status" placeholder="请选择状态" class="ele-block" clearable>
                        <el-option v-for="item in []" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="状态：" prop="siteswitch">
                    <el-select v-model="editForm.siteswitch" placeholder="请选择状态" class="ele-block" clearable>
                        <el-option v-for="item in []" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="小数输入框：" prop="flot_price">
                    <el-input-number v-model="editForm.flot_price" controls-position="right" :min="0"
                        placeholder="请输入小数输入框" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="文本框：" prop="area_text">
                    <el-input v-model="editForm.area_text" placeholder="请输入文本框" clearable />
                </el-form-item>

                <el-form-item label="时间选择器：" prop="datetime">
                    <el-input-number v-model="editForm.datetime" controls-position="right" :min="0"
                        placeholder="请输入时间选择器" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="日期组件：" prop="date_info">
                    <el-input-number v-model="editForm.date_info" controls-position="right" :min="0"
                        placeholder="请输入日期组件" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="日期时间组件：" prop="timestamp">
                    <el-input-number v-model="editForm.timestamp" controls-position="right" :min="0"
                        placeholder="请输入日期时间组件" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="时间日期其他：" prop="datetimessss">
                    <el-input-number v-model="editForm.datetimessss" controls-position="right" :min="0"
                        placeholder="请输入时间日期其他" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="会员id单选：" prop="user_id">
                    <el-input-number v-model="editForm.user_id" controls-position="right" :min="0"
                        placeholder="请输入会员id单选" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="多id合集：" prop="user_ids">
                    <el-input v-model="editForm.user_ids" placeholder="请输入多id合集" clearable />
                </el-form-item>

                <el-form-item label="管理员id：" prop="admin_id">
                    <el-input-number v-model="editForm.admin_id" controls-position="right" :min="0"
                        placeholder="请输入管理员id" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="管理员id多选：" prop="admin_ids">
                    <el-input v-model="editForm.admin_ids" placeholder="请输入管理员id多选" clearable />
                </el-form-item>

                <el-form-item label="关联表id：" prop="store_goods_category_id">
                    <el-input-number v-model="editForm.store_goods_category_id" controls-position="right" :min="0"
                        placeholder="请输入关联表id" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="关联表id多选：" prop="store_goods_category_ids">
                    <el-input v-model="editForm.store_goods_category_ids" placeholder="请输入关联表id多选" clearable />
                </el-form-item>

                <el-form-item label="权重：" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :min="0" placeholder="请输入权重"
                        class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="单图：" prop="smallimage">
                    <el-input v-model="editForm.smallimage" placeholder="请输入单图" clearable />
                </el-form-item>

                <el-form-item label="多图：" prop="smallimages">
                    <el-input v-model="editForm.smallimages" placeholder="请输入多图" clearable />
                </el-form-item>

                <el-form-item label="单文件：" prop="attachfile">
                    <el-input v-model="editForm.attachfile" placeholder="请输入单文件" clearable />
                </el-form-item>

                <el-form-item label="多文件：" prop="attachfiles">
                    <el-input v-model="editForm.attachfiles" placeholder="请输入多文件" clearable />
                </el-form-item>

                <el-form-item label="当头像：" prop="miniavatar">
                    <el-input v-model="editForm.miniavatar" placeholder="请输入当头像" clearable />
                </el-form-item>

                <el-form-item label="多头像：" prop="miniavatars">
                    <el-input v-model="editForm.miniavatars" placeholder="请输入多头像" clearable />
                </el-form-item>

                <el-form-item label="富文本：" prop="maincontent">
                    <el-input-number v-model="editForm.maincontent" controls-position="right" :min="0"
                        placeholder="请输入富文本" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="日期范围：" prop="daterange">
                    <el-input v-model="editForm.daterange" placeholder="请输入日期范围" clearable />
                </el-form-item>

                <el-form-item label="日期时间范围：" prop="datetimierange">
                    <el-input v-model="editForm.datetimierange" placeholder="请输入日期时间范围" clearable />
                </el-form-item>

                <el-form-item label="时间范围：" prop="timerange">
                    <el-input v-model="editForm.timerange" placeholder="请输入时间范围" clearable />
                </el-form-item>

                <el-form-item label="金额小数：" prop="decimal_price">
                    <el-input-number v-model="editForm.decimal_price" controls-position="right" :min="0"
                        placeholder="请输入金额小数" class="ele-fluid ele-text-left" />
                </el-form-item>

                <el-form-item label="地图选址：" prop="city_map">
                    <el-input v-model="editForm.city_map" placeholder="请输入地图选址" clearable />
                </el-form-item>

                <el-form-item label="地区选址：" prop="address_region">
                    <el-input v-model="editForm.address_region" placeholder="请输入地区选址" clearable />
                </el-form-item>

                <el-form-item label="创建时间：" prop="create_time">
                    <el-input-number v-model="editForm.create_time" controls-position="right" :min="0"
                        placeholder="请输入创建时间" class="ele-fluid ele-text-left" />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="showEdit=false">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "SysCeshi",
        data() {
            return {
                table: {
                    url: '/ceshi/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {}, // 表单数据
                editRules: { // 表单验证规则

                    title_unit: [{
                        required: true,
                        message: '请输入金额（元）',
                        trigger: 'blur'
                    }],

                    phone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }],

                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],

                    store_num: [{
                        required: true,
                        message: '请输入商城数量',
                        trigger: 'blur'
                    }],

                    status: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'blur'
                    }],

                    show_status: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'blur'
                    }],

                    siteswitch: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'blur'
                    }],

                    flot_price: [{
                       required: true,
                        message: '请输入小数输入框',
                        trigger: 'blur'
                    }],

                    area_text: [{
                        required: true,
                        message: '请输入文本框',
                        trigger: 'blur'
                    }],

                    datetime: [{
                        required: true,
                        message: '请输入时间选择器',
                        trigger: 'blur'
                    }],

                    date_info: [{
                       required: true,
                        message: '请输入日期组件',
                        trigger: 'blur'
                    }],

                    timestamp: [{
                        required: true,
                        message: '请输入日期时间组件',
                        trigger: 'blur'
                    }],

                    datetimessss: [{
                       required: true,
                        message: '请输入时间日期其他',
                        trigger: 'blur'
                    }],

                    user_id: [{
                        required: true,
                        message: '请输入会员id单选',
                        trigger: 'blur'
                    }],

                    user_ids: [{
                       required: true,
                        message: '请输入多id合集',
                        trigger: 'blur'
                    }],

                    admin_id: [{
                        required: true,
                        message: '请输入管理员id',
                        trigger: 'blur'
                    }],

                    admin_ids: [{
                        required: true,
                        message: '请输入管理员id多选',
                        trigger: 'blur'
                    }],

                    store_goods_category_id: [{
                        required: true,
                        message: '请输入关联表id',
                        trigger: 'blur'
                    }],

                    store_goods_category_ids: [{
                        required: true,
                        message: '请输入关联表id多选',
                        trigger: 'blur'
                    }],

                    sort: [{
                        required: true,
                        message: '请输入权重',
                        trigger: 'blur'
                    }],

                    smallimage: [{
                        required: true,
                        message: '请输入单图',
                        trigger: 'blur'
                    }],

                    smallimages: [{
                        required: true,
                        message: '请输入多图',
                        trigger: 'blur'
                    }],

                    attachfile: [{
                        required: true,
                        message: '请输入单文件',
                        trigger: 'blur'
                    }],

                    attachfiles: [{
                       required: true,
                        message: '请输入多文件',
                        trigger: 'blur'
                    }],

                    miniavatar: [{
                        required: true,
                        message: '请输入当头像',
                        trigger: 'blur'
                    }],

                    miniavatars: [{
                        required: true,
                        message: '请输入多头像',
                        trigger: 'blur'
                    }],

                    maincontent: [{
                        required: true,
                        message: '请输入富文本',
                        trigger: 'blur'
                    }],

                    daterange: [{
                        required: true,
                        message: '请输入日期范围',
                        trigger: 'blur'
                    }],

                    datetimierange: [{
                        required: true,
                        message: '请输入日期时间范围',
                        trigger: 'blur'
                    }],

                    timerange: [{
                        required: true,
                        message: '请输入时间范围',
                        trigger: 'blur'
                    }],

                    decimal_price: [{
                       required: true,
                        message: '请输入金额小数',
                        trigger: 'blur'
                    }],

                    city_map: [{
                        required: true,
                        message: '请输入地图选址',
                        trigger: 'blur'
                    }],

                    address_region: [{
                        required: true,
                        message: '请输入地区选址',
                        trigger: 'blur'
                    }],

                    create_time: [{
                        required: true,
                        message: '请输入创建时间',
                        trigger: 'blur'
                    }],

                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {},
        methods: {
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/ceshi/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.editForm = res.data.data;
                        this.showEdit = true;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的测试吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/ceshi/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /**
             * 更改状态
             */
            status(row) {
                const loading = this.$loading({
                    lock: true
                });
                let params = Object.assign({}, row);
                this.$http.post("/ceshi/status", params).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row.status = !row.status ? 2 : 1;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
